import { Component } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-access-code-by-token',
  templateUrl: './access-code-by-token.component.html',
  styleUrls: ['./access-code-by-token.component.scss']
})
export class AccessCodeByTokenComponent {
  isLoading: boolean = true; // Initially loading is true
  url: any;
  redirectURL: any;
  authGuid: any;
  accessCode: any;
  previousUrl: any;
  constructor(
    private commonService: CommonService,
    private restService: RestService,
    private loader: LoaderService,
    private navigationService: NavigationService
  ) {
    this.previousUrl = this.navigationService.getPreviousUrl();
    console.log('Previous URL:', this.previousUrl);
    this.getAppDetails();
  }

  getAppDetails() {
    this.loader.show();
    const fullUrl = window.location.href;
    // Create a new URL object
    const url = new URL(fullUrl);

    // Extract the path without the domain
    const pathWithoutDomain = url.pathname;
    console.log(pathWithoutDomain);
    let param = {
      //requestedPageURL: window.parent.location.pathname + window.parent.location.search
      requestedPageURL: this.previousUrl + window.parent.location.search,
    };
    this.restService.postUADLogin(param, 'api/UAD/GetDomainDetails').subscribe(
      (data) => {
        if (data.rcode == 200) {
          this.loader.hide();
          let redirect_url = data.rObj.redirectURL;
          if (redirect_url) {
            window.location.href = redirect_url;
          }
        } else {
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.commonService.handleStatusError(error);
      }
    );
  }
}

